import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { getOrdersByDateTime } from "../ordersThunk";
import { OrdersResponce, OrdersState } from "../types";
import { CustomError } from "shared/api";

export const getOrderByDateTimeReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getOrdersByDateTime.pending, state => {
			state.loading = true;
			state.loadedTable = null;
			state.ordersByTable = [];
			state.loadingError = ''
		})
		.addCase(
			getOrdersByDateTime.fulfilled,
			(state, action: PayloadAction<OrdersResponce>) => {
				state.loading = false;
				state.orders = action.payload.results;
				state.stats = action.payload.stats;
				state.error = null;
			},
		)
		.addCase(getOrdersByDateTime.rejected, (state, action) => {
			state.loading = false;
			state.stats = {
				appointments: 'error',
				participants: 'error',
			};
			state.loadingError = 'Произошла ошибка загрузки данных'
			state.error = action.payload as CustomError;
		})
}